var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-file-env',{attrs:{"isEdit":"","fileEnvId":+_vm.$route.params.fileEnvId,"cancelRoute":'File env'}})
}
var staticRenderFns = []

export { render, staticRenderFns }